/** Vercel Blob folder for game audio (same filenames as former `public/assets/sound/*.mp3`). */
export const SOUNDS_BLOB_BASE =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/sounds' as const

const sound = (stem: string) => `${SOUNDS_BLOB_BASE}/${stem}.mp3`

export const AUDIO_CHARACTERS_URL = sound('characters')
export const AUDIO_CLICK_URL = sound('click')
export const AUDIO_INVENTORY_URL = sound('inventory')
export const AUDIO_MARKET_URL = sound('market')
export const AUDIO_LAND_URL = sound('land')
export const AUDIO_SOL_URL = sound('sol')
export const AUDIO_MINI_GAME_URL = sound('mini-game')
export const AUDIO_MAIN_URL = sound('main')
export const AUDIO_PVP_URL = sound('pvp')
export const AUDIO_PVE_URL = sound('pve')
export const AUDIO_SAKURA_URL = sound('sakura')
export const AUDIO_RENA_URL = sound('rena')
export const AUDIO_HAYATE_URL = sound('hayate')
export const AUDIO_MOTOKO_URL = sound('motoko')

/**
 * Onet Connect ("Eclipsera Bonds") one-shots. Still served from `public/assets/sound/`
 * — these three are not on the blob yet; point them at `sound(...)` once they are uploaded.
 */
export const AUDIO_ONET_MATCH_TILE_URL = '/assets/sound/onet-matchtile.mp3'
export const AUDIO_ONET_WIN_URL = '/assets/sound/onet-win.mp3'
export const AUDIO_ONET_DEFEAT_URL = '/assets/sound/onet-defeat.mp3'

/** MvM / hex battle one-shots on blob (`sounds/mvm/*.mp3`). */
export const AUDIO_MVM_SWORD_CLASH_URL = `${SOUNDS_BLOB_BASE}/mvm/sword-clash.mp3`
export const AUDIO_MVM_ATTACK_URL = `${SOUNDS_BLOB_BASE}/mvm/attack.mp3`
export const AUDIO_MVM_MAN_UGH_URL = `${SOUNDS_BLOB_BASE}/mvm/man-ugh-sound.mp3`
export const AUDIO_MVM_WOMAN_UGH_URL = `${SOUNDS_BLOB_BASE}/mvm/woman-ugh-sound.mp3`